<template>
  <div id="permissionsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="permissionSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
              <v-icon left>security</v-icon> {{ $t('permission.add') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                  >
                    <v-text-field
                      clearable
                      required
                      :rules="rules.required"
                      :label="$t('general.name')"
                      :error-messages="errors.name"
                      v-model="editedItem.name"
                      @keyup.enter="save"
                    >
                    </v-text-field>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                color="primary"
                round
                class="white--text"
                depressed
                :loading="loading"
                :disabled="loading"
                @click="save"
                >
                  {{ $t('general.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
      :search="permissionSearch"
      class="elevation-2"
      :headers="headers"
      :items="permissions"
      :rows-per-page-items="[10,15,25]"
      :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{header.text}}</h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{props.item.id}}</td>
            <td class="text-sm-center">{{props.item.name}}</td>
            <td>
              <v-layout row justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                      small
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <v-btn
                    outline
                    icon
                    color="error"
                    v-on="on"
                    @click="removed(props.item)"
                    small
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                    </template>
                    <span>{{ $t('general.delete') }}</span>
                  </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('permission.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('permission.description') }}: </span>{{removedItem.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              round
              depressed
              @click="deleteItem(removedItem)">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'areasComponent',
  data () {
    return {
      permissionSearch: '',
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dialog: false,
      valid: true,
      loading: false,
      disabled: false,
      removeDialog: false,
      removedItem: {},
      editedIndex: -1,
      error: false,
      errors: {},
      errorMessage: '',
      permissions: [],
      editedItem: {
        name: ''
      },
      defaultItem: {
        name: ''
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.permissions')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-user-shield fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('permission.add') : this.$t('permission.edit')
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.get()
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deleteItem (item) {
      const index = this.permissions.indexOf(item)
      this.delete(item, index)
      this.removeDialog = false
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.loading = false
      this.disabled = true
      this.$refs.form.resetValidation()
    },
    editItem (item) {
      this.editedIndex = this.permissions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.disabled = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    get () {
      this.$emit('get', {
        context: this
      })
    },
    post () {
      this.$emit('post', {
        item: this.editedItem,
        context: this
      })
    },
    put () {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    delete (item, index) {
      this.$emit('delete', {
        item: item,
        index: index,
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/permissions.component.vue